import React, { FC } from 'react';

import Switch from 'common/components/Switch';

import { SettingItemProps } from './modules';
import { StyledTr } from './styles';

const SettingItem: FC<SettingItemProps> = ({
  index,
  item,
  handleChangeNotifications,
  displaySmsColumn,
}) => {
  return (
    <StyledTr isColored={index % 2 === 0}>
      <td>
        <div>
          <p>{item.name}</p>
        </div>
      </td>
      {displaySmsColumn && (
        <td>
          <div>
            <Switch
              checked={item.smsEnabled}
              onChange={() =>
                handleChangeNotifications({
                  ...item,
                  smsEnabled: !item.smsEnabled,
                })
              }
            />
          </div>
        </td>
      )}
      <td>
        <div>
          <Switch
            checked={item.pushEnabled}
            onChange={() =>
              handleChangeNotifications({
                ...item,
                pushEnabled: !item.pushEnabled,
              })
            }
          />
        </div>
      </td>
      <td>
        <div>
          <Switch
            checked={item.emailEnabled}
            onChange={() =>
              handleChangeNotifications({
                ...item,
                emailEnabled: !item.emailEnabled,
              })
            }
          />
        </div>
      </td>
    </StyledTr>
  );
};
export default SettingItem;
